<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-input v-model="keywords" placeholder="搜索"></el-input>
        <el-button @click="_getList(1)" type="primary">搜索</el-button>
        <!-- <el-button @click="export2Excel" ref="exportData">导出为xls</el-button> -->
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow"
        >
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table
          ref="multipleTable"
          :data="userDatas"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column
          type="selection"
          width="60">
        </el-table-column> -->
          <el-table-column prop="id" label="会员ID" width="80">
          </el-table-column>
          <el-table-column prop="userName" label="会员账号" width="100">
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="120">
          </el-table-column>
          <el-table-column
            prop="vip"
            :formatter="getVipText"
            label="会员等级"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.cashCoupon"
            label="消费券"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="userAccountVo.qtValue" label="JF" width="80">
          </el-table-column>
          <el-table-column
            prop="userAccountVo.qtQuota"
            label="JF配额"
            width="80"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="userAccountVo.uvalue"
            label="消费权重"
            width="120"
          >
          </el-table-column> -->
          <el-table-column prop="inviterUserName" label="上级" width="120">
          </el-table-column>
          <!-- <el-table-column prop="registerWeight" label="注册权重" width="120">
          </el-table-column> -->
          <!-- <el-table-column
            prop="userAccountVo.totalEarnings"
            label="个人收益总额"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="userAccountVo.balance" label="余额" width="80">
          </el-table-column> -->
          <!--        <el-table-column-->
          <!--          prop="subordinateNumber"-->
          <!--          label="推荐人数"-->
          <!--          width="100">-->
          <!--        </el-table-column>-->
          <el-table-column
            prop="userAccountVo.subsidyRate"
            label="市场费率"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.principal"
            label="现金券"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="insertTime" label="注册时间" width="160">
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleShowPush(scope.row)"
                >查看已推荐人</el-button
              >
              <!-- <el-button
              size="mini"
              @click="handleShowDetail(scope.row)">详情</el-button>
            <el-button
             size="mini"
             @click="handleEdit(scope.$index, scope.row)">修改资料</el-button>  -->
              <el-button size="mini" @click="editFunc(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                @click="handleFreeze(scope.row, 1)"
                v-if="scope.row.state == 0"
                >冻结账号</el-button
              >
              <el-button
                size="mini"
                @click="handleFreeze(scope.row, 0)"
                v-if="scope.row.state == 1"
                >解冻账号</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除账号</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="已推荐人"
        :visible.sync="pushDialogVisible"
        width="70%"
        :append-to-body="true"
        center
      >
        <!-- <el-table :data="recommendedUsers" border>  pushUserDatas-->
        <el-table :data="pushUserDatas" border>
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="userName" label="用户名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="insertTime" label="注册时间"></el-table-column>
          <!-- <el-table-column prop="vip" label="VIP等级"></el-table-column> -->
          <el-table-column
            prop="vip"
            :formatter="getVipText"
            label="会员等级"
            width="80"
          >
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="pushDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="freezeDialogVisible"
        width="20%"
        center
        :append-to-body="true"
      >
        <span>确定要冻结当前用户吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="freezeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="freezeUser()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body="true"
        center
      >
        <span>确定要删除当前用户吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteUser()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="编辑"
        :visible.sync="editFrame"
        width="40%"
        :append-to-body="true"
        center
      >
        <div class="editFrameStyle">
          <div class="editChildFrame">
            <div>
              <span>会员账号:</span>
            </div>
            <div class="editFrameIpt">
              <el-input
                placeholder="请输入会员账号"
                v-model="editForm.userName"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="editChildFrame">
            <div>
              <span>手机号码:</span>
            </div>
            <div class="editFrameIpt">
              <el-input
                placeholder="请输入手机号码"
                v-model="editForm.phone"
                type="number"
                clearable
              >
              </el-input>
            </div>
          </div>
          <div class="editChildFrame">
            <div>
              <span>市场费率:</span>
            </div>
            <div class="editFrameIpt">
              <el-input
                placeholder="请输入市场费率"
                v-model="editForm.subsidyRate"
                type="number"
                clearable
              >
              </el-input>
            </div>
          </div>
          <div class="editChildFrame">
            <div>
              <span>积分:</span>
            </div>
            <div class="editFrameIpt">
              <el-input
                placeholder="请输入积分"
                v-model="editForm.principal"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="editChildFrame">
            <div>
              <span>代金券:</span>
            </div>
            <div class="editFrameIpt">
              <el-input
                placeholder="请输入代金券"
                v-model="editForm.cashCoupon"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="editChildFrame">
            <div>
              <span>QT配额:</span>
            </div>
            <div class="editFrameIpt">
              <el-input
                placeholder="请输入QT配额"
                v-model="editForm.qtQuota"
                type="number"
                clearable
              >
              </el-input>
            </div>
          </div>
          <div class="editChildFrame">
            <div>
              <span>会员等级:</span>
            </div>
            <div class="editFrameIpt">
              <el-select
                placeholder="请选择会员等级"
                v-model="editForm.vip"
                clearable
              >
                <el-option
                  v-for="(item, index) in memberShipList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="editChildFrame">
            <div>
              <span>权限密码:</span>
            </div>
            <div class="editFrameIpt">
              <el-input
                placeholder="请输入权限密码进行修改"
                v-model="editForm.password"
                clearable
              ></el-input>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editFrame = false">取 消</el-button>
          <el-button type="primary" @click="editPostFunc">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getAllUser,
  saveUser,
  deleteUser, //删除的接口
  freezeUser, //冻结当前用户
  getPushUser, //已推荐人的信息
  updateMemberById,
} from "api/request";
import { getDepartment } from "api/post";
import { ERR_OK } from "api/config";
import { formatDate, loadingInstance, Success, Error } from "common/js/util";
export default {
  components: { MSidebar, MHeader },
  data() {
    return {
      isSubmitting: false,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {},
      userDetail: [],
      userDatas: [],
      pushUserDatas: [], //推荐人
      multipleSelection: [],
      // recommendedUsers: [], //推荐人
      editFrame: false,
      editForm: {
        userName: "",
        phone: "",
        vip: "",
        subsidyRate: "",
        qtQuota: "",
        principal: "",
        cashCoupon: "",
        password: "",
      },
      memberShipList: [
        {
          label: "非会员",
          value: -1,
        },
        {
          // label: "体验",
          // label: "龙金卡",
          label: "一星会员",
          value: 0,
        },
        {
          // label: "金牌",
          // label: "龙钻卡",
          label: "二星会员",
          value: 1,
        },
        {
          // label: "总代",
          // label: "龙宾卡",
          label: "三星会员",
          value: 2,
        },
        {
          // label: "联创",
          // label: "龙尊卡",
          label: "四星会员",
          value: 3,
        },
        {
          // label: "董事",
          // label: "龙帝卡",
          // label: "总代会员",
          // value: 4
        },
      ],
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/",
      });
    } else {
      this._getList();
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 编辑
    editFunc(data) {
      this.editFrame = true;
      // 赋值
      console.log(data);
      this.editForm = {
        id: data.id,
        userName: data.userName,
        phone: data.phone,
        vip: Number(data.vip),
        subsidyRate: data.userAccountVo.subsidyRate,
        qtQuota: "",
        principal: data.userAccountVo.principal,
        cashCoupon: data.userAccountVo.cashCoupon,
      };
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChange(val) {
      console.log(val);
      this.pageNum = val;
      this.userDatas = [];
      this._getList();
    },
    // 删除账号
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.userDatas[index];
    },
    handleEdit(index, row) {
      this.editDialogVisible = true;
      this.controlData = this.userDatas[index];
    },
    handleShowDetail(row) {
      this.detailDialogVisible = true;
      this.userDetail = [row];
    },
    // 查看已推荐人
    handleShowPush(row) {
      this.pushDialogVisible = true;
      this._getPushList(row.id);
    },
    getVipText(row) {
      // 0.不是会员    1.vip     2.银卡   3.金卡    4.钻卡
      if (row.vip < 0) {
        return "非代理";
      }
      // let vipMap={0:'体验代理',1:'金牌代理',2:'总代理',3:'联创代理',4:'董事'}
      let vipMap = {
        0: "一星会员",
        1: "二星会员",
        2: "三星会员",
        3: "四星会员",
        4: "五星会员",
      };
      return vipMap[row.vip];
    },
    edit() {
      let param = {
        userid: getUserInfo.userid,
        saveId: this.controlData.userid,
        password: this.controlData.password,
      };
      loadingInstance(Loading);
      saveUser(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 冻结当前用户
    handleFreeze(data, status) {
      let param = {
        state: status,
        id: data.id,
      };
      loadingInstance(Loading);
      freezeUser(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    deleteUser() {
      let param = {
        id: this.controlData.id,
      };
      loadingInstance(Loading);
      deleteUser(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.deleteDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    _getList(i) {
      let param = {
        content: this.keywords,
        current: this.pageNum,
        size: this.pageSize,
      };
      if (i != null) {
        param.current = 1;
      }
      loadingInstance(Loading);
      getAllUser(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.userDatas = res.data.records;
          this.totalNum = res.data.total;
          if (res.data.pages > 1) {
            this.paginationShow = true;
          }
        } else {
          Error(this, res);
        }
      });
    },
    // 推荐列表
    _getPushList(userId) {
      let param = {
        current: 1,
        size: 100,
        userId: userId,
      };
      loadingInstance(Loading);
      getPushUser(userId).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.pushUserDatas = res.data.records;
        } else {
          Error(this, res);
        }
      });
    },
    export2Excel() {
      var exportList = this.multipleSelection;
      let arr = [];
      for (var i = 0; i < this.exportList.length; i++) {
        let obj = {};
        obj.id = this.exportList[i].id;
        obj.userName = this.exportList[i].userName;
        obj.insertTime = this.exportList[i].insertTime;
        obj.balance = this.exportList[i].userAccountVo.balance;
        obj.recommendNum = this.exportList[i].recommendNum;
        arr.push(obj);
      }
      require.ensure([], () => {
        const { exportJsonToExcel } = require("../../vendor/Export2Excel");
        const tHeader = [
          "会员ID",
          "会员账号",
          "注册时间",
          "US余额",
          "推荐人数",
        ];
        const filterVal = [
          "id",
          "userName",
          "insertTime",
          "balance",
          "recommendNum",
        ];
        const list = arr;
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "用户列表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 编辑确定按钮
    editPostFunc() {
      if (this.isSubmitting) return;
      console.log("值", this.editForm.password);
      if (this.editForm.password !== "ykkj18624986819") {
        this.$message({
          type: "error",
          message: "权限密码错误",
        });
        return;
      }
      // 设置提交状态为 true
      this.isSubmitting = true;
      updateMemberById(this.editForm)
        .then((res) => {
          this.$message({
            type: "success",
            message: res.message,
          });
          if (res.status == 200) {
            console.log(res);

            // 关闭
            this.editFrame = false;
            //
            this._getList();
          }
        })
        .finally(() => {
          // 无论成功或失败，最后都要重置提交状态
          this.isSubmitting = false;
        });
    },
  },
};
</script>
<style scoped>
.userOperate {
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.userTable {
  padding: 10px;
  position: relative;
}
</style>
<style>
.editFrameIpt {
  margin-left: 20px;
  width: 200px;
}
.userOperate .el-input {
  width: 180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width: 100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
.editFrameStyle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.editChildFrame {
  margin: 10px 0;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue